import dashboardLocale from './en.json'

const en = {
  dashboard: dashboardLocale,
}

export default en
